
import anime from 'animejs';
import { mmMatches } from '../utils/utils.matchmedia';

const 	accordions = document.querySelectorAll('.js-accordion');

if ( accordions ) {

	let 	accordionItems, accordionHeadings, accordionContents;

	accordions.forEach( item => {
		accordionItems = item.querySelectorAll('.js-accordion-item'),
		accordionHeadings = item.querySelectorAll('.js-accordion-heading'),
		accordionContents = item.querySelectorAll('.js-accordion-content');

		hideAccordionContents(accordionContents);
		addClickEvents(accordionHeadings);
	});

	function handleHeadingClick( e ) {
		let target = e.target,
			mainItem = target.closest('.js-accordion-item'),
			content = target.nextElementSibling,
			contentHeight,
			paddingTop = mmMatches('desktop') ? 20 : ( mmMatches('small-tablet') ? 10 : 5 );

		if ( mainItem.classList.contains('is-active') ) {
			mainItem.classList.remove('is-active');
		} else {
			mainItem.classList.add('is-active');
		}

		if ( content.classList.contains('is-hidden') ) {

			content.classList.remove('is-hidden');
			contentHeight = getItemContentsHeight(content);

			anime({
				targets: content,
				height: [0, contentHeight + paddingTop],
				paddingTop: [0, paddingTop],
				duration: 333,
				easing: 'easeInOutQuad'
			});
		} else {

			content.classList.add('is-hidden');

			anime({
				targets: content,
				height: [content.clientHeight, 0],
				paddingTop: [paddingTop, 0],
				duration: 333,
				easing: 'easeInOutQuad'
			});
		}
	}

	function getItemContentsHeight(content) {
		const 	elements = [...content.children]

		return 	elements
					.map( item => {
						let height = item.offsetHeight,
						style = getComputedStyle(item);
					  	height += parseInt(style.marginTop) + parseInt(style.marginBottom);

					  	return height;
					})
					.reduce( (prev, curr) => prev + curr );
	}

	function hideAccordionContents( accordionContents ) {
		accordionContents.forEach( item => {
			item.classList.add('is-hidden');
		});
	}

	function addClickEvents( accordionHeadings ) {
		accordionHeadings.forEach( item => {
			item.addEventListener('click', handleHeadingClick);
		});
	}
}
